import { Button } from "@design";
import { GitFork } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";

/** Shown instead of the composer on a chat someone shared with you. */
export function ForkBar({
  owner,
  forking,
  onFork,
}: Readonly<{ owner?: string | null; forking: boolean; onFork: () => void }>) {
  const { t } = useTranslation("chat", { keyPrefix: "actions" });
  return (
    <div className="border-t border-border-subtle bg-surface-primary px-4 py-3">
      <div className="mx-auto flex max-w-[720px] flex-wrap items-center justify-between gap-3">
        <Text tone="secondary">{owner ? t("sharedBy", { name: owner }) : t("sharedWithYou")}</Text>
        <Button variant="primary" size="sm" leadingIcon={<GitFork size={14} />} loading={forking} onClick={onFork}>
          {t("forkToContinue")}
        </Button>
      </div>
    </div>
  );
}
